import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { TemplateListQuery } from '../../helpers/videoTemplates/dispatchCurrentTemplate';
import dispatchGetInitialProps from '../../helpers/videoTemplates/dispatchGetInitialProps';

const useTemplateListStoreInit = (
  params: TemplateListQuery,
  canInit: boolean
) => {
  const dispatch = useDispatch();

  useEffect(() => {
    canInit && dispatchGetInitialProps({ dispatch, query: params });
  }, [params, canInit]);
};

export default useTemplateListStoreInit;
